import { render, staticRenderFns } from "./createWebsiteStep2.vue?vue&type=template&id=553e47cd&scoped=true"
import script from "./createWebsiteStep2.vue?vue&type=script&lang=js"
export * from "./createWebsiteStep2.vue?vue&type=script&lang=js"
import style0 from "./createWebsiteStep2.vue?vue&type=style&index=0&id=553e47cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e47cd",
  null
  
)

export default component.exports